module.exports = __webpack_public_path__ + "static/20250403.ffa1c5b4.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/20250403.png
// module id = 1001
// module chunks = 2